var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppDarkSchemePreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 209,
  height: 138,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-dark-scheme-preview_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3A3A3A",
  d: "M.667 9.6c0-3.36 0-5.04.653-6.324A6 6 0 0 1 3.943.654C5.226 0 6.906 0 10.267 0h188.799c3.361 0 5.041 0 6.324.654a6 6 0 0 1 2.623 2.622c.654 1.284.654 2.964.654 6.324v118.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.623 2.622c-1.283.654-2.963.654-6.324.654h-188.8c-3.36 0-5.04 0-6.323-.654a6 6 0 0 1-2.623-2.622C.667 133.44.667 131.76.667 128.4z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#app-dark-scheme-preview_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-dark-scheme-preview_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 212,
  height: 124,
  x: 24.666,
  y: 24,
  fill: "#fff",
  fillOpacity: 0.035,
  rx: 8,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-dark-scheme-preview_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.667 24h76v124h-76z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.035,
  d: "M24.667 24h76v124h-76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M99.667 24v124h2V24z",
  mask: "url(#app-dark-scheme-preview_svg__d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 32.666,
  y: 34,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 80.666,
  y: 34,
  fill: "#555",
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.666,
  y: 72,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.666,
  y: 84,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.666,
  y: 96,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.666,
  y: 108,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32.666,
  y: 120,
  fill: "#555",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 4,
  x: 48.666,
  y: 38,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 42.666,
  y: 73,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 4,
  x: 42.666,
  y: 85,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 4,
  x: 42.666,
  y: 97,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 4,
  x: 42.666,
  y: 109,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 4,
  x: 42.666,
  y: 121,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 10,
  x: 32.666,
  y: 54,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-dark-scheme-preview_svg__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.667 24h132v30h-132z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.035,
  d: "M100.667 24h132v30h-132z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M232.667 53h-132v2h132z",
  mask: "url(#app-dark-scheme-preview_svg__e)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 108.667,
  y: 34,
  fill: "#555",
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 122.667,
  y: 37,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 4,
  x: 108.667,
  y: 62,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 109.167,
  y: 72.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 109.167,
  y: 114.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  x: 180.667,
  y: 62,
  fill: "#555",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 181.167,
  y: 72.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 181.167,
  y: 114.5,
  fill: "#fff",
  fillOpacity: 0.035,
  stroke: "#555",
  rx: 3.5
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "app-dark-scheme-preview_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.667 9.6c0-3.36 0-5.04.653-6.324A6 6 0 0 1 3.943.654C5.226 0 6.906 0 10.267 0h188.799c3.361 0 5.041 0 6.324.654a6 6 0 0 1 2.623 2.622c.654 1.284.654 2.964.654 6.324v118.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.623 2.622c-1.283.654-2.963.654-6.324.654h-188.8c-3.36 0-5.04 0-6.323-.654a6 6 0 0 1-2.623-2.622C.667 133.44.667 131.76.667 128.4z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "app-dark-scheme-preview_svg__c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 212,
  height: 124,
  x: 24.666,
  y: 24,
  fill: "#fff",
  rx: 8
})), /*#__PURE__*/React.createElement("filter", {
  id: "app-dark-scheme-preview_svg__b",
  width: 276,
  height: 188,
  x: -11.334,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_507_3293"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_507_3293",
  result: "shape"
})))));
export { SvgAppDarkSchemePreview as ReactComponent };
export default "data:image/svg+xml;base64,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";